<template>
    <div>
        <div class="p-3 my-3 bg-light">
            <strong>補足情報</strong>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputError from '@/components/InputError.vue'

export default {
    components: {
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
</style>

